var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":_vm.phoneOnly,"depressed":"","color":"primary","large":"","rounded":"","min-width":"250px"},on:{"click":_vm.load}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-message-processing-outline")]),_c('strong',[_vm._v("ابدأ المحادثة")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }